<template>
  <div class="bankList">
    <!-- هدر -->
    <span class="fRow jBetween aCenter fullWidth h">
      لیست سؤالات
      <div class="b fRow jStart aCenter">
        <i class="material-icons-round">get_app</i>
        <label>دانلود اکسل</label>
      </div>
    </span>
    <!-- فیلترها و دکمه‌ی سرچ -->
    <div class="fRow jBetween aStart wrap filtersHolder"
      style="box-shadow: 0 8px 16px 0 rgba(0,0,0,0.15); z-index: 10">
      <div class="filterBox w50 fRow jStart aCenter">
        <div class="ih fullWidth fCol jStart aStart">
          <span>انتخاب رشته</span>
          <cool-select
            class="fullWidth"
            @select="selected($event, 'field')"
            v-model="filterField"
            disable-search
            :items="fields"
            :item-value="fields.id"
            :item-text="fields.title">
            <!-- slot for each item in the menu -->
            <template slot="item" slot-scope="{ item: field }">
              <div style="display: flex; align-items: center;">
                <div>
                  {{ field.title }}
                  <b>{{ field.value }}</b>
                </div>
              </div>
            </template>
            <!-- slot for the selected item (in the text field) -->
            <template slot="selection" slot-scope="{ item: field }">
              <div>
                {{ field.title }}
                <b>{{ field.value }}</b>
              </div>
            </template>
          </cool-select>
        </div>
      </div>
      <div class="filterBox w50 fRow jStart aCenter">
        <div class="ih fullWidth fCol jStart aStart">
          <span>انتخاب پایه</span>
          <cool-select
            class="fullWidth"
            @select="selected($event, 'grade')"
            v-model="filterGrade"
            disable-search
            :items="grades"
            :item-value="grades.id"
            :item-text="grades.title">
            <!-- slot for each item in the menu -->
            <template slot="item" slot-scope="{ item: grade }">
              <div style="display: flex; align-items: center;">
                <div>
                  {{ grade.title }}
                  <b>{{ grade.value }}</b>
                </div>
              </div>
            </template>
            <!-- slot for the selected item (in the text field) -->
            <template slot="selection" slot-scope="{ item: grade }">
              <div>
                {{ grade.title }}
                <b>{{ grade.value }}</b>
              </div>
            </template>
          </cool-select>
        </div>
      </div>
      <div class="filterBox w50 fRow jStart aCenter">
        <div class="ih fullWidth fCol jStart aStart">
          <span>انتخاب درس</span>
          <cool-select
            class="fullWidth"
            @select="selected($event, 'lesson')"
            v-model="filterLesson"
            disable-search
            :items="lessons"
            :item-value="lessons.id"
            :item-text="lessons.title">
            <!-- slot for each item in the menu -->
            <template slot="item" slot-scope="{ item: lesson }">
              <div style="display: flex; align-items: center;">
                <div>
                  {{ lesson.title }}
                  <b>{{ lesson.value }}</b>
                </div>
              </div>
            </template>
            <!-- slot for the selected item (in the text field) -->
            <template slot="selection" slot-scope="{ item: lesson }">
              <div>
                {{ lesson.title }}
                <b>{{ lesson.value }}</b>
              </div>
            </template>
          </cool-select>
        </div>
      </div>
      <div class="filterBox w50 fRow jStart aCenter">
        <div class="ih fullWidth fCol jStart aStart">
          <span>انتخاب طبقه بندی</span>
          <cool-select
            class="fullWidth"
            @select="selected($event, 'classification')"
            v-model="filterClassification"
            :items="classifications"
            :item-value="classifications.id"
            :item-text="classifications.title">
            <!-- slot for each item in the menu -->
            <template slot="item" slot-scope="{ item: classification }">
              <div style="display: flex; align-items: center;">
                <div>
                  {{ classification.title }}
                  <b>{{ classification.value }}</b>
                </div>
              </div>
            </template>
            <!-- slot for the selected item (in the text field) -->
            <template slot="selection" slot-scope="{ item: classification }">
              <div>
                {{ classification.title }}
                <b>{{ classification.value }}</b>
              </div>
            </template>
          </cool-select>
        </div>
      </div>
      <div class="w66 fCol jStart aStart inputHolder filterBox"
        v-if="resultLoaded && bank.length > 0"
        style="margin-bottom: 0;">
        <span class="fRow jStart aCenter">متن سؤال</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <input @keyup.enter="newAssignment"
            class="transition-fast" placeholder="متن سؤال"
            type="text" v-model="search">
        </div>
      </div>
      <div class="filterBox w50 fRow jStart aCenter"
        v-if="resultLoaded && bank.length > 0 && false">
        <div class="ih fullWidth fCol jStart aStart">
          <span>نوع سؤال</span>
          <cool-select
            class="fullWidth"
            v-model="filterType"
            disable-search
            :items="types"/>
        </div>
      </div>
      <div class="filterBox w33 fRow jStart aCenter"
        v-if="resultLoaded && bank.length > 0">
        <div class="ih fullWidth fCol jStart aStart">
          <span>سطح سؤال</span>
          <cool-select
            class="fullWidth"
            v-model="filterLevel"
            disable-search
            :items="levels" />
        </div>
      </div>
      <div class="b fRow jCenter aCenter fullWidth big"
        v-bind:class="{active: isReadyToSearch}"
        @click="getQuestion"
        style="margin: 8px 8px 16px">
        <i class="material-icons-round">search</i>
        <label>جستجو در بانک سؤالات</label>
      </div>
    </div>
    <div class="fCol jCenter aCenter fullWidth"
      v-if="!loaded || noContent">
      <p-bar
        :loading="loading"
        :notYet="notYet"
        :noContent="noContent"
        :notFound="notFound"
        :error="error" />
    </div>
    <!-- <div class="fCol jCenter aCenter fullWidth notYet"
      v-if="!resultLoaded">
      <h4>هنوز جستجو نکرده‌اید</h4>
      <p>جهت مشاهده‌ی سؤالات ابتدا جستجو کنید</p>
    </div>
    <div class="fCol jCenter aCenter fullWidth notFound"
      v-if="resultLoaded && filteredBank.length === 0">
      <h4>سؤالی یافت نشد</h4>
      <p>لطفا در رشته‌ها و دروس دیگر جستجو کنید</p>
    </div> -->
    <ul class="fullWidth" v-if="true"
      @scroll="qlistScrolled"
      ref="questionList"
      style="z-index: 5">
      <li class="fRow jStart aStart"
        v-for="(item, index) in filteredBank" v-bind:key="index"
        v-bind:class="{selected: findInArray(item.id) !== -1}"
        @click="selectQ(item)">
        <!-- <div class="qindex">{{index + 1}}</div> -->
        <div class="qQuestion growFull fCol jStart aStart">
          <!-- آیکون سطح، ایندکس، متن سؤال و عکس -->
          <div class="fullWidth fRow jStart aCenter">
            <i class="material-icons-round hard" title="سؤال سخت"
              v-if="item.level === 1">sentiment_neutral</i>
            <i class="material-icons-round normal" title="سؤال معمولی"
              v-if="item.level === 2">sentiment_satisfied</i>
            <i class="material-icons-round easy" title="سؤال آسان"
              v-if="item.level === 3">sentiment_very_satisfied</i>
            <div class="fCol jCenter aStart">
              <!-- <span class="q fullWidth">{{index + 1}} - {{item.title}}</span> -->
              <quill-editor ref="myTextEditor"
                class="fullWidth qlClass"
                v-model="item.title"
                :disabled="true"
                :options="qItemQuillOptions"></quill-editor>
              <img :src="`${baseURL}/exam/${item.img}`" class="qImg"
                v-if="item.img !== null && item.img.length > 0"/>
            </div>
          </div>
          <!-- گزینه های سؤال -->
          <div class="qOptions" v-if="item.isTest">
            <div class="op fCol jCenter aStart"
              v-for="(option, index) in item.options" v-bind:key="index"
              v-bind:class="{trueAnswer: option.correctAnswer}">
              <!-- <p>{{option.text}}</p> -->
              <quill-editor ref="myTextEditor"
                class="fullWidth qlClass"
                v-model="option.text"
                :disabled="true"
                :options="qItemQuillOptions"></quill-editor>
              <img :src="`${baseURL}/exam/${option.media}`"
                v-if="option.media !== undefined && option.media !== ''" />
            </div>
          </div>
          <div class="fRow jStart aCenter" style="margin-top: 16px">
            <div class="b lesson fRow jStart aCenter mini">
              <i class="material-icons-round">menu_book</i>
              <label>{{item.lesson}}</label>
            </div>
            <div class="b lesson fRow jStart aCenter mini">
              <i class="material-icons-round">category</i>
              <label>{{item.field}}</label>
            </div>
            <div class="b lesson fRow jStart aCenter mini">
              <i class="material-icons-round">toc</i>
              <label>{{item.grade}}</label>
            </div>
          </div>
        </div>
        <div class="fCol jCenter aCenter"
          style="margin-right: 8px">
          <div class="fRow"
            v-if="(from === 'add' && !forceDisable) && findInArray(item.id) === -1">
            <i class="material-icons-round">check_box_outline_blank</i>
          </div>
          <div class="fRow"
            v-if="(from === 'add' && !forceDisable) && findInArray(item.id) !== -1">
            <i class="material-icons-round">check_box</i>
          </div>
          <div class="b fRow fab"
            v-if="from === 'exam' && !forceDisable"
            @click="askToDelete(index)"
            style="background-color: #ef3422">
            <i class="material-icons-round" style="color: white">delete</i>
          </div>
          <div class="b fRow fab"
            v-if="from === 'exam' && !forceDisable"
            @click="editThisQuestion(index)"
            style="margin-top: 8px;">
            <i class="material-icons-round">edit</i>
          </div>
        </div>
        <div class="innerModal fCol jCenter aCenter"
          v-if="modal && focusedQuestion === index">
          <h4>آیا از حذف سؤال مطمئن هستید؟</h4>
          <div class="fRow jStart aCenter">
            <div class="b fRow jStart aCenter red"
              @click="deleteQuestion(item.id)">
              <i class="material-icons-round">delete</i>
              <label>بله، حذف شود</label>
            </div>
            <div class="b fRow jStart aCenter mini"
              @click="modal = false">
              <i class="material-icons-round">cancel</i>
              <label>لغو</label>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="addSelected fRow jBetween aCenter fullWidth primary"
      @click="sendQuestions"
      v-if="questions.length > 0">
      <div class="fRow jStart aCenter">
        <i class="material-icons-round" style="margin-left: 8px">add</i>
        <label>اضافه کردن سؤالات انتخاب شده</label>
      </div>
      <div class="b fRow jStart aCenter">
        <label>{{questions.length}} سؤال انتخاب شده</label>
      </div>
    </div>
  </div>
</template>

<script>
import { CoolSelect } from 'vue-cool-select';
import 'vue-cool-select/dist/themes/material-design.scss';
import { EventBus } from '@/plugins/event-bus';
import axios from 'axios';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import pBar from './pBar.vue';

export default {
  props: ['from'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      qItemQuillOptions: {
        placeholder: 'متن گزینه را وارد کنید',
        theme: 'bubble',
        modules: {
          toolbar: [
            ['formula', 'clean'],
            ['bold', 'underline'],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: true,
      loaded: false,
      modeMsg: '',
      // modes ↑
      resultLoaded: false,
      forceDisable: false,
      // فیلد
      fields: [
        {
          id: '',
          title: 'حذف فیلتر',
        },
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      filterField: '',
      filterFieldId: '',
      fFieldIdErr: true,
      // گرید
      grades: [
        {
          title: 'لطفا رشته را انتخاب کنید',
          id: '',
        },
      ],
      filterGrade: '',
      fGradeErr: true,
      // درس
      lessons: [
        {
          id: '',
          title: 'ابتدا رشته و پایه را انتخاب کنید',
        },
      ],
      filterLesson: '',
      fLessonErr: true,
      // classification
      classifications: [
        {
          id: '',
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      filterClassification: '',
      fClassificationErr: true,
      types: [
        'تستی',
        'تشریحی',
        'همه',
      ],
      filterType: '',
      fTypeValue: 0,
      levels: [
        'آسان',
        'متوسط',
        'سخت',
        'همه',
      ],
      filterLevel: '',
      fLevelValue: 0,
      fLevelErr: true,
      // bank
      search: '',
      bank: [],
      questions: [],
      // modal
      modal: false,
      focusedQuestion: '',
    };
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    selectQ(item) {
      console.error(this.from);
      if (this.from === 'add') {
        const ind = this.findInArray(item.id);
        if (ind === -1) {
          this.questions.push(item);
        } else {
          this.questions.splice(ind, 1);
        }
      }
    },
    sendQuestions() {
      this.$emit('nq', this.questions);
      this.questions = [];
    },
    findInArray(id) {
      let ind = -1;
      for (let i = 0; i < this.questions.length; i += 1) {
        if (this.questions[i].id === id) {
          ind = i;
        }
      }
      return ind;
    },
    // dynamic fields
    getFields() {
      this.fields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const f = response.data.data;
        if (response.data.isSuccess) {
          if (f.length === 0) {
            this.filterGrade = {};
            this.filterLesson = {};
            this.grades = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.lessons = [
              {
                id: -1,
                title: 'ابتدا رشته را انتخاب کنید',
              },
            ];
            this.fields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            // this.classGradeErr = true;
            this.filterGrade = {};
            // this.classLessonErr = true;
            this.filterLesson = {};
            this.fields = [];
            for (let i = 0; i < f.length; i += 1) {
              const item = {
                id: f[i].id,
                title: f[i].title,
              };
              this.fields.push(item);
            }
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.classFields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.classFields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    getGrades(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== '') {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      } else {
        return;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          this.grades.push({
            id: '',
            title: 'حذف فیلتر',
          });
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.grades);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getLessons(f) {
      this.lessons = ['لطفا صبر کنید'];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.lessons = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.lessons.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.lessons);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getQuestion() {
      if (this.isReadyToSearch) {
        this.setMode('loading');
        axios({
          method: 'get',
          url: this.getQuestionUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.bank = [];
            const bank = response.data.data;
            for (let i = 0; i < bank.length; i += 1) {
              const q = {
                id: bank[i].id,
                title: bank[i].text,
                img: bank[i].media,
                level: bank[i].level,
                lesson: bank[i].lessonName,
                lessonId: bank[i].lessonId,
                grade: bank[i].gradeName,
                gradeId: bank[i].gradeId,
                field: this.fieldName(bank[i].field),
                isTest: bank[i].type === 1,
                options: bank[i].options,
              };
              this.bank.push(q);
            }
            // console.log(this.bank);
            if (this.bank.length === 0) {
              this.setMode('noContent');
            } else {
              this.setMode('loaded');
            }
          } else {
            this.setMode('error', 'خطایی رخ داده، دوباره تلاش کنید');
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.setMode('error', this.errorHandler(error));
        }).catch(() => {
          // eslint-disable-next-line
          this.setMode('error', 'اتصال به اینترنت را بررسی کنید، درصورت عدم رفع مشکل با تیم فنی تماس بگیرید');
        });
      } else {
        // console.log('fill search form');
      }
    },
    askToDelete(index) {
      this.modal = true;
      this.focusedQuestion = index;
    },
    deleteQuestion(id) {
      axios({
        method: 'delete',
        url: `${this.baseURL}/api/v${this.V}/Questions/${id}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.focusedQuestion = '';
          this.getQuestion();
        } else {
          // console.log('wrong, cant delete');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    editThisQuestion(id) {
      EventBus.$emit('edit', this.filteredBank[id]);
    },
    selected(e, dropDown) {
      // console.log(e, dropDown);
      switch (dropDown) {
        case 'field': {
          if (e.id !== '' && e.id !== undefined) {
            // console.warn(e.id);
            // console.log('رشته انتخاب شد');
            this.getGrades(e.id);
            this.fFieldIdErr = false;
            this.fGradeErr = true;
            this.fLessonErr = true;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fFieldIdErr = true;
            this.fGradeErr = true;
            this.fLessonErr = true;
            // ریست کردن لیست ها
            this.grades = [{
              title: 'رشته را انتخاب کنید',
              id: '',
            }];
            this.filterGrade = {};
            this.lessons = [{
              title: 'رشته و پایه را انتخاب کنید',
              id: '',
            }];
            this.filterLesson = {};
          }
          break;
        }
        case 'grade': {
          if (e.id !== '' && e.id !== undefined) {
            // console.warn(e.id);
            // console.log('پایه انتخاب شد');
            this.getLessons(e.id);
            this.fGradeErr = false;
            this.fLessonErr = true;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fGradeErr = true;
            this.fLessonErr = true;
            // ریست کردن لیست ها
            this.lessons = [{
              title: 'پایه را انتخاب کنید',
              id: '',
            }];
            this.filterLesson = {};
            this.filterGrade = {};
          }
          break;
        }
        case 'lesson': {
          if (e.id !== '' && e.id !== undefined) {
            this.fLessonErr = false;
            this.getQuestion();
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fLessonErr = true;
            // ریست کردن لیست ها
            this.lessons = [{
              title: 'پایه را انتخاب کنید',
              id: '',
            }];
            this.filterLesson = {};
          }
          break;
        }
        case 'classification': {
          if (e.id !== '' && e.id !== undefined) {
            this.fClassificationErr = false;
          } else {
            // اگر حذف فیلتر انتخاب شد
            this.fClassificationErr = true;
          }
          break;
        }
        default:
          break;
      }
    },
    fieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    getClassification() {
      this.classifications = ['لطفا صبر کنید'];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classifications = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            // ریست کردن لیست ها
            this.classifications = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.classifications.push({
                id: arr[i].id,
                title: arr[i].name,
              });
            }
          }
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    qlistScrolled() {
      const el = this.$refs.questionList;
      const isNearEnd = el.scrollTop > el.scrollHeight - (el.clientHeight + 300);
      console.log(isNearEnd);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.katex = katex;
      this.getFields();
      this.getClassification();
      // this.$refs.questionList.addEventListener('onscroll', (e) => {
      //   console.log(e);
      // });
      EventBus.$on('refreshQuestionBank', () => {
        this.getQuestion();
      });
      EventBus.$on('clearSelected', () => {
        this.questions = [];
      });
      EventBus.$on('updateBankSelected', (e) => {
        this.questions = e;
      });
      EventBus.$on('disableAdd', () => {
        this.forceDisable = true;
      });
      EventBus.$on('enableAdd', () => {
        this.forceDisable = false;
      });
    });
  },
  components: {
    CoolSelect,
    pBar,
    quillEditor,
  },
  computed: {
    questionsReady() {
      return this.loaded && this.bank.length > 0;
    },
    isReadyToSearch() {
      return !this.fFieldIdErr || !this.fClassificationErr;
    },
    getQuestionUrl() {
      let c = '';
      if (!this.fClassificationErr) {
        c = `&classificiationId=${this.filterClassification.id}`;
      }
      if (this.isReadyToSearch) {
        // const isFieldSelected = this.filterFieldId !== 0 && this.filterFieldId !== '';
        // const isGradeSelected = this.filterGrade !== '';
        // const isLessonSelected = this.filterLesson !== '';
        let url = '';
        if (!this.fFieldIdErr && !this.fGradeErr && !this.fLessonErr) {
          // eslint-disable-next-line
          url = `${this.baseURL}/api/v${this.V}/Questions?gradeId=${this.filterGrade.id}&lessonId=${this.filterLesson.id}&fieldType=${this.filterField.id}${c}`;
        } else if (!this.fFieldIdErr && !this.fGradeErr) {
          // eslint-disable-next-line
          url = `${this.baseURL}/api/v${this.V}/Questions?gradeId=${this.filterGrade.id}&fieldType=${this.filterField.id}${c}`;
        } else if (!this.fFieldIdErr) {
          url = `${this.baseURL}/api/v${this.V}/Questions?fieldType=${this.filterField.id}${c}`;
        // eslint-disable-next-line
        } else if (this.fFieldIdErr && this.fGradeErr && this.fLessonErr && !this.fClassificationErr) {
          // eslint-disable-next-line
          url = `${this.baseURL}/api/v${this.V}/Questions?classificiationId=${this.filterClassification.id}`;
        }
        return url;
      }
      return '';
    },
    isFilteredBySearch() {
      return this.search.length > 0;
    },
    isFilteredByType() {
      return this.fTypeValue !== 0;
    },
    isFilteredByLevel() {
      return this.fLevelValue !== 0;
    },
    filteredBank() {
      let array = [];
      // simple conds
      if (this.isFilteredBySearch && this.isFilteredByType && this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase())
        || item.level === this.fLevelValue
        || item.type === this.fTypeValue);
      }
      if (!this.isFilteredBySearch && !this.isFilteredByType && !this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank;
      }
      // 2 conds
      if (this.isFilteredBySearch && !this.isFilteredByType && !this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase()));
      }
      if (!this.isFilteredBySearch && !this.isFilteredByType && this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.level === this.fLevelValue);
      }
      if (!this.isFilteredBySearch && this.isFilteredByType && !this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.type === this.fTypeValue);
      }
      // 1 conds
      if (!this.isFilteredBySearch && this.isFilteredByType && this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.level === this.fLevelValue
        || item.type === this.fTypeValue);
      }
      if (this.isFilteredBySearch && !this.isFilteredByType && this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase())
        && item.level === this.fLevelValue);
      }
      if (this.isFilteredBySearch && this.isFilteredByType && !this.isFilteredByLevel) {
        // eslint-disable-next-line
        array = this.bank.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase())
        || item.level === this.fTypeValue);
      }
      // console.log(array);
      return array;
    },
  },
  watch: {
    filterLevel() {
      switch (this.filterLevel) {
        case 'آسان': {
          this.fLevelValue = 3;
          break;
        }
        case 'متوسط': {
          this.fLevelValue = 2;
          break;
        }
        case 'سخت': {
          this.fLevelValue = 1;
          break;
        }
        case 'همه': {
          this.fLevelValue = 0;
          break;
        }
        default:
          break;
      }
      // console.warn(this.fLevelValue);
    },
    filterType() {
      switch (this.filterType) {
        case 'تستی': {
          this.fTypeValue = 1;
          break;
        }
        case 'تشریحی': {
          this.fTypeValue = 2;
          break;
        }
        default:
          break;
      }
      // console.warn(this.fTypeValue);
    },
    modal() {
      if (!this.modal) {
        this.focusedQuestion = '';
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  .bankList {
    min-width: 450px;
    width: 450px;
    min-height: 312px;
    border-radius: 4px;
    box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
      0 8px 8px 0 rgba($color: #000000, $alpha: 0.1);
    span.h {
      padding: 16px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.11);
    }
    .filterBox {
      padding: 8px 8px 0 8px;
      span {
        font-size: 12px;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 450px;
      position: relative;
      overflow: hidden auto;
      li {
        list-style-type: none;
        position: relative;
        padding: 16px;
        border-bottom: 1px dashed rgba($color: #000000, $alpha: 0.25);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          margin-left: 16px;
          span.q {
            font-size: 13px;
            font-weight: 200;
            text-align: right;
          }
          .qImg {
            max-width: 264px;
            border-radius: 8px;
            margin-top: 8px;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
          .qOptions {
            width: 100%;
            .op {
              padding: 2px 16px 2px 2px;
              border-right: 2px solid rgba(0, 0, 0, 0.247);
              width: 100%;
              margin-top: 8px;
              margin-right: 10px;
              p {
                font-size: 12px;
                text-align: right;
                margin: 0;
              }
              img {
                margin: 8px 0;
                border-radius: 8px;
                border: solid 1px rgba($color: #000000, $alpha: 0.25);
                width: 112px;
              }
            }
            .op.trueAnswer {
              border-right: 2px solid rgb(38, 148, 57) !important;
              background-color: rgba(38, 148, 56, 0.074);
              border-radius: 8px 0 0 8px;
            }
          }
        }
        .qAddToList {
          width: 32px;
          min-width: 32px;
          margin-right: 16px;
          i {
            font-size: 16px;
          }
        }
        .innerModal {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          background-color: rgba($color: #ffffff, $alpha: 1);
        }
      }
      li.selected {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      li.selected:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.0);
      }
    }
    .addSelected {
      cursor: pointer;
      padding: 16px;
      * {
        pointer-events: none;
      }
      i {
        color: white;
        margin-left: 8px;
      }
      label {
        color: white;
      }
    }
    .notYet {
      min-height: 182px;
      h4 {
        font-size: 24px;
        font-weight: 500;
        color: rgba($color: #000000, $alpha: 0.35);
      }
      p {
        padding: 0;
        margin: 0;
        font-size: 16px;
        font-weight: 200;
        color: rgba($color: #000000, $alpha: 0.25);
      }
    }
    .notFound {
      min-height: 182px;
      h4 {
        font-size: 24px;
        font-weight: 500;
        color: rgba($color: #000000, $alpha: 1);
      }
      p {
        padding: 0;
        margin: 0;
        font-size: 16px;
        font-weight: 200;
        color: rgba($color: #000000, $alpha: 1);
      }
    }
  }
</style>
